module.exports = __webpack_public_path__ + "static/media/8.228b2fa7.jpg";